import {Injectable} from '@angular/core';
import {runInAction} from 'mobx';
import {map} from 'rxjs/operators';
import {Model} from '../app.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Block} from './phonenumber.model';
import { Observable } from 'rxjs';

export type LacList = { is_filtered: boolean, lac_list: { caption: string; value: string }[] }

@Injectable()
export class PhonenumberService {
  private needsRefresh = true;

  constructor(private httpClient: HttpClient, private m: Model) {

  }

  public refresh(force: boolean = false) {
    if (this.needsRefresh || force) {
      this.httpClient.get<any[]>('/services/trunk/block/all')
        .pipe(map((r) => r.map((item) => Block.fromJson(item))))
        .subscribe((r) => runInAction(() => {
          this.m.phonenumber.blocks = r;
          this.needsRefresh = false;
        }));
    }
  }

  public getPhoneNumberById(blockId: number): Observable<Block> {
    return this.httpClient.get<any>('/services/trunk/block/' + blockId)
      .pipe(map((r) => 
        Block.fromJson(r))
      );
  }

  public getPhonenumberUsedInSubscriptionSize(applianceId: string, blocks: Block[], saleOrderName?: string): number {
    let usedInSubscription = 0;
    blocks.map(r => {
      if (r.appliance.appliance_id === applianceId) {
        if (r.origin !== 'ported' && (!saleOrderName || r.saleOrderName !== saleOrderName)) {
          usedInSubscription += r.numbers.length;
        }
      }
    });
    return usedInSubscription;
  }

  public removePhoneNumber(blockId: number) {
    this.httpClient.delete('/services/trunk/block/' + blockId).subscribe(_ => {
      this.refresh(true);
    });
  }

  public getLacList(saleOrderName: string) {
    let params = new HttpParams();
    params = params.append('sale_order', saleOrderName);
    return this.httpClient.get<LacList>('/services/trunk/lac', { params });
  }

  public getPhoneNumbersForPartnerOffer(token: string, offer: string) {
    return this.httpClient.get<any>(`/services/subscriptions/offer/shared/${offer}/trunk/blocks`, {params: { token }})
      .pipe(map((r) => r.map((item) => Block.fromJson(item))));
  }

}
